export default __webpack_public_path__ + "static/media/face_and_id.5eed308e.png";